import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledTabList = styled('ul')((props) => {
    const {
        theme: { borderRadius, colors }
    } = props;

    return css`
        margin: 0;
        display: inline-flex;
        list-style: none;
        padding: 2px;
        overflow-x: auto;
        text-align: center;
        background-color: ${colors['graphic-background-accent-light']};
        border-radius: ${borderRadius['4px']};
        max-width: 100%;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
            display: none; /* Chrome */
        }
    `;
});

export const StyledTab = styled('li')<{ isSelected?: boolean }>((props) => {
    const {
        theme: { borderRadius, spacing, colors, fontWeight, focusRing },
        isSelected
    } = props;

    return css`
        padding: 0.625rem 0;
        align-items: center;
        justify-content: center;
        white-space: nowrap;

        a {
            text-decoration: none;
            font-weight: ${isSelected ? fontWeight['bold'] : 'normal'};
            color: ${isSelected ? colors.white : colors['text-body']};
            line-height: 1.5rem;
            outline: none;
            padding: 0.725rem ${spacing['16px']};
            background-color: ${isSelected
                ? colors['graphic-background-contrast']
                : colors['transparent']};
            border: 0;
            border-radius: ${borderRadius['4px']};
            cursor: pointer;
            &:focus {
                box-shadow: ${focusRing};
                outline: 0;
                z-index: 1;
            }
        }
    `;
});
